import { PostHogConfig } from "posthog-js";
import { PUBLIC_POSTHOG_HOST } from ".";

export const postHogConfig: Partial<PostHogConfig> = {
  api_host: PUBLIC_POSTHOG_HOST,
  capture_pageview: false,
  ui_host: "https://eu.posthog.com",
};
